import {useForm} from 'react-hook-form';

const useGstForm = ({defaultValues, onSubmitHandler}) => {
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm({
    defaultValues,
  });

  const onSubmit = data => {
    if (onSubmitHandler) {
      onSubmitHandler(data);
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
  };
};

export default useGstForm;
